import {Nullable, Optional} from '../../Common/TypeHelper'

export type Address = {
  postCode: string
  addressPrefectureCode: Nullable<Optional<string>>
  addressCity: Nullable<Optional<string>>
  addressStreet: Nullable<Optional<string>>
  addressBuilding: Nullable<Optional<string>>
}

export type ContactAddress = Address & {
  phoneMobile: Nullable<Optional<string>>
  phoneTel: Nullable<Optional<string>>
}

export class MemberAddressDTO implements ContactAddress{
  postCode: string
  addressPrefectureCode: Nullable<Optional<string>>
  addressCity: Nullable<Optional<string>>
  addressStreet: Nullable<Optional<string>>
  addressBuilding: Nullable<Optional<string>>
  phoneMobile: Nullable<Optional<string>>
  phoneTel: Nullable<Optional<string>>

  constructor(
    postCode: string,
    addressPrefectureCode: Nullable<Optional<string>>,
    addressCity: Nullable<Optional<string>>,
    addressStreet: Nullable<Optional<string>>,
    addressBuilding: Nullable<Optional<string>>,
    phoneMobile: Nullable<Optional<string>>,
    phoneTel: Nullable<Optional<string>>,
  ) {
    this.postCode = postCode
    this.addressPrefectureCode = addressPrefectureCode
    this.addressCity = addressCity
    this.addressStreet = addressStreet
    this.addressBuilding = addressBuilding
    this.phoneMobile = phoneMobile
    this.phoneTel = phoneTel
  }
}

